import React, { useEffect, useState, useRef } from "react";
import Lottie from "lottie-react";
import "../styles/BackgroundAnimation.css";

// Dynamically import all .json files from animations folder
function importAll(r) {
  return r.keys().map((key) => {
    const anim = r(key);
    return anim.default || anim; // Ensure compatibility
  });
}

const animations = importAll(
  require.context("../assets/animations", false, /\.json$/)
);

const BackgroundAnimation = () => {
  const [index, setIndex] = useState(0);
  const timeoutRef = useRef(null);

  useEffect(() => {
    timeoutRef.current = setInterval(() => {
      setIndex((prev) => (prev + 1) % animations.length);
    }, 10000); // 10 seconds

    return () => clearInterval(timeoutRef.current);
  }, []);

  return (
    <div className="background-animation-wrapper">
      <Lottie
        animationData={animations[index]}
        loop
        autoplay
      />
    </div>
  );
};

export default BackgroundAnimation;
